import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowCircleRight,
  faArrowCircleLeft,
} from '@fortawesome/free-solid-svg-icons';
import { textGrey } from '~theme';

import taskListStyles from '~styles/taskListStyles.scss';

function getTransferDirection(task, user) {
  const isOrderer = user.ordererOrganization && user.ordererOrganization.id;
  const userOrgId = user.ordererOrganization.id;

  if (isOrderer) {
    if (task.observer && userOrgId === task.observer.id) {
      return 'Yksikköön saapuva kuljetus';
    } else if (task.observer && userOrgId === task.consumer.id) {
      return 'Yksiköstä lähtevä kuljetus';
    }
  }
}

const TransferInfoRow = ({ task, user }) => {
  const transferDirection = getTransferDirection(task, user);

  return (
    !!transferDirection && (
      <div className={taskListStyles.statusField}>
        <TransferDirection>
          {transferDirection === 'Yksiköstä lähtevä kuljetus' ? (
            <TransferDirectionIcon icon={faArrowCircleLeft} />
          ) : (
            <TransferDirectionIcon icon={faArrowCircleRight} />
          )}
          {transferDirection}
        </TransferDirection>
      </div>
    )
  );
};

const TransferDirection = styled.div`
  margin-right: 16px;
  flex: 1;
  font-weight: 700;
  color: ${textGrey};
`;
const TransferDirectionIcon = styled(FontAwesomeIcon)`
  font-size: 14px;
  margin-right: 6px;
  color: black;
`;

export default TransferInfoRow;
